import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Realmente toma solo 15 minutos?',
  a: "Sí, porque eliminamos el paso de 'picar y preparar' usando ingredientes inteligentes."
}, {
  q: '¿Es caro comprar cosas pre-listas?',
  a: 'Al contrario, sale un 60% más barato que pedir comida o comprar ingredientes que luego se echan a perder.'
}, {
  q: '¿La comida es saludable?',
  a: 'Absolutamente. Nos enfocamos en comida real, proteínas de calidad y vegetales, evitando los químicos de la comida ultra-procesada.'
}, {
  q: '¿Necesito herramientas especiales?',
  a: 'Solo un microondas, un sartén básico y, opcionalmente, una Air Fryer.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-brand-bg-alt" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-25">
          <h2 className="text-4xl md:text-5xl mb-6 text-brand-dark" data-id="element-26">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-stone-200 overflow-hidden" data-id="element-28">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-29">
                <span className="font-bold text-lg text-brand-dark font-sans pr-8" data-id="element-30">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-stone-400 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
              </button>
              <AnimatePresence data-id="element-32">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-33">
                    <div className="px-6 pb-5 text-stone-600 leading-relaxed" data-id="element-34">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}